/**
 * BYOB Bundle Builder
 * Custom replacement for Rebuy BYOB widget
 * Handles: tabs, product grid, bundle sidebar, discounts, cart
 */
(function () {
  'use strict';

  var C = window.BYOB_CONFIG;
  if (!C) return;

  /* ═══ State ═══ */
  var activeTab = 0;
  var bundle = [];          // [{ product, variant, qty }]
  var orderType = 'onetime'; // 'onetime' | 'subscription'
  var selVariants = {};      // productId -> variantId

  /* ═══ DOM refs ═══ */
  var root, tabsEl, gridEl, sidebarEl;

  /* ═══════════════════════════════════════════
     Helpers
     ═══════════════════════════════════════════ */
  function fmt(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function unitInfo(title, priceCents) {
    var m = title.match(/^(\d+)\s/);
    if (m && parseInt(m[1], 10) > 1) {
      var qty = parseInt(m[1], 10);
      return title + ' - ' + fmt(Math.round(priceCents / qty)) + ' each';
    }
    return title;
  }

  function escHTML(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function subtotal() {
    var s = 0;
    for (var i = 0; i < bundle.length; i++) s += bundle[i].variant.price * bundle[i].qty;
    return s;
  }

  function activeDiscount() {
    var st = subtotal(), d = 0;
    for (var i = 0; i < C.tiers.length; i++) {
      if (st >= C.tiers[i].amount * 100) d = C.tiers[i].discount;
    }
    return d;
  }

  function discountedTotal() {
    var d = activeDiscount(), st = subtotal();
    return d > 0 ? Math.round(st * (1 - d / 100)) : st;
  }

  function totalItems() {
    var n = 0;
    for (var i = 0; i < bundle.length; i++) n += bundle[i].qty;
    return n;
  }

  function findItem(vid) {
    for (var i = 0; i < bundle.length; i++) {
      if (bundle[i].variant.id === vid) return bundle[i];
    }
    return null;
  }

  // True if at least one variant of the product is in stock.
  // Products with no available variants are hidden from the grid;
  // BYOB_CONFIG is rebuilt by Liquid on every page load, so they
  // reappear automatically once inventory is restocked.
  function hasStock(product) {
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) return true;
    }
    return false;
  }

  /* ═══════════════════════════════════════════
     Bundle Actions
     ═══════════════════════════════════════════ */
  function addItem(product, variant) {
    if (!variant.available) return;
    if (totalItems() >= C.maxItems) return;
    var existing = findItem(variant.id);
    if (existing) {
      existing.qty++;
    } else {
      bundle.push({ product: product, variant: variant, qty: 1 });
    }
    refresh();
  }

  function removeItem(vid) {
    bundle = bundle.filter(function (i) { return i.variant.id !== vid; });
    refresh();
  }

  function adjustQty(vid, delta) {
    var item = findItem(vid);
    if (!item) return;
    if (item.qty + delta <= 0) { removeItem(vid); return; }
    if (totalItems() + delta > C.maxItems) return;
    item.qty += delta;
    refresh();
  }

  /* ═══════════════════════════════════════════
     Rendering
     ═══════════════════════════════════════════ */
  function refresh() {
    renderGrid();
    renderSidebar();
  }

  /* ─── Tabs ─── */
  function renderTabs() {
    var html = '';
    for (var i = 0; i < C.tabs.length; i++) {
      html += '<button class="byob-tab' + (i === 0 ? ' is-active' : '') + '" data-action="tab" data-tab="' + i + '">'
        + '<span class="byob-tab__label">' + escHTML(C.tabs[i].label) + '</span>'
        + '<span class="byob-tab__sub">Choose from this collection of products</span>'
        + '</button>';
    }
    html += '<button class="byob-tab__top" data-action="scroll-top">'
      + '<svg width="10" height="8" viewBox="0 0 10 8"><path d="M5 0L0 8h10z" fill="currentColor"/></svg> Top'
      + '</button>';
    tabsEl.innerHTML = html;
  }

  /* ─── Product Grid ─── */
  function renderGrid() {
    var all = C.tabs[activeTab] ? C.tabs[activeTab].products : [];
    var products = all.filter(hasStock);
    var d = activeDiscount();
    if (!products.length) {
      gridEl.innerHTML = all.length
        ? '<p class="byob-empty">All products in this collection are currently sold out. Please check back soon.</p>'
        : '<p class="byob-empty">No products in this collection yet. Select a collection in the theme customizer.</p>';
      return;
    }
    var html = '<div class="byob-grid">';
    for (var i = 0; i < products.length; i++) {
      html += cardHTML(products[i], d);
    }
    html += '</div>';
    gridEl.innerHTML = html;
  }

  function cardHTML(product, disc) {
    var vid = selVariants[product.id];
    if (!vid) {
      for (var k = 0; k < product.variants.length; k++) {
        if (product.variants[k].available) { vid = product.variants[k].id; break; }
      }
      if (!vid && product.variants[0]) vid = product.variants[0].id;
    }
    var variant = null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].id === vid) { variant = product.variants[i]; break; }
    }
    if (!variant) variant = product.variants[0];
    if (!variant) return '';

    var item = findItem(variant.id);
    var inBundle = !!item;
    var origPrice = variant.price;
    var salePrice = disc > 0 ? Math.round(origPrice * (1 - disc / 100)) : origPrice;

    // Price display
    var priceHTML = disc > 0
      ? '<span class="byob-card__price--sale">' + fmt(salePrice) + '</span> <span class="byob-card__price--orig">' + fmt(origPrice) + '</span>'
      : '<span>' + fmt(origPrice) + '</span>';

    // Variant selector
    var selectHTML = '<select class="byob-card__select" data-product-id="' + product.id + '">';
    for (var v = 0; v < product.variants.length; v++) {
      var pv = product.variants[v];
      selectHTML += '<option value="' + pv.id + '"'
        + (pv.id === variant.id ? ' selected' : '')
        + (!pv.available ? ' disabled' : '')
        + '>' + escHTML(pv.title) + ' - ' + fmt(pv.price) + (!pv.available ? ' (Sold Out)' : '') + '</option>';
    }
    selectHTML += '</select>';

    // Action (add or qty)
    var actionHTML;
    if (inBundle) {
      actionHTML = '<div class="byob-card__qty">'
        + '<button class="byob-card__qty-btn" data-action="qty-minus" data-variant-id="' + variant.id + '">\u2212</button>'
        + '<span class="byob-card__qty-val">' + item.qty + '</span>'
        + '<button class="byob-card__qty-btn" data-action="qty-plus" data-variant-id="' + variant.id + '">+</button>'
        + '</div>';
    } else {
      actionHTML = variant.available
      ? '<button class="byob-card__add" data-action="add" data-product-id="' + product.id + '" data-variant-id="' + variant.id + '">Add To Bundle</button>'
      : '<button class="byob-card__add" disabled>Sold Out</button>';
    }

    var productUrl = '/products/' + product.handle;
    return '<div class="byob-card" data-product-id="' + product.id + '">'
      + '<a class="byob-card__img" href="' + productUrl + '" target="_blank" rel="noopener">'
      +   '<img src="' + escHTML(product.image) + '" alt="' + escHTML(product.title) + '" loading="lazy" width="300" height="300">'
      + '</a>'
      + '<a class="byob-card__title-link" href="' + productUrl + '" target="_blank" rel="noopener">'
      +   '<h3 class="byob-card__title">' + escHTML(product.title) + '</h3>'
      + '</a>'
      + '<p class="byob-card__variant-info">' + escHTML(unitInfo(variant.title, variant.price)) + '</p>'
      + '<div class="byob-card__price-wrap">' + priceHTML + '</div>'
      + selectHTML
      + actionHTML
      + '</div>';
  }

  /* ─── Sidebar ─── */
  function renderSidebar() {
    var count = totalItems();
    var st = subtotal();
    var d = activeDiscount();
    var dt = discountedTotal();
    var maxAmt = C.tiers[C.tiers.length - 1].amount * 100;
    var pct = Math.min(100, (st / maxAmt) * 100);

    // Next unlock hint
    var hint = '';
    for (var t = 0; t < C.tiers.length; t++) {
      if (st < C.tiers[t].amount * 100) {
        hint = 'Buy ' + fmt(C.tiers[t].amount * 100) + ' and unlock ' + C.tiers[t].discount + '%';
        break;
      }
    }

    // Progress markers
    var maxTierAmt = C.tiers[C.tiers.length - 1].amount;
    var markers = '';
    for (var m = 0; m < C.tiers.length; m++) {
      var pos = (C.tiers[m].amount / maxTierAmt) * 100;
      markers += '<span class="byob-progress__marker" style="left:' + pos + '%">' + C.tiers[m].discount + '%</span>';
    }

    // Bundle items
    var itemsHTML = '';
    for (var i = 0; i < bundle.length; i++) {
      var bi = bundle[i];
      var itemTotal = bi.variant.price * bi.qty;
      var itemDisc = d > 0 ? Math.round(itemTotal * (1 - d / 100)) : itemTotal;
      var priceStr = d > 0
        ? '<span class="byob-price--sale">' + fmt(itemDisc) + '</span> <span class="byob-price--orig">' + fmt(itemTotal) + '</span>'
        : fmt(itemTotal);

      itemsHTML += '<div class="byob-sidebar__item">'
        + '<div class="byob-sidebar__item-img"><img src="' + escHTML(bi.product.image) + '" alt="" width="60" height="60"></div>'
        + '<div class="byob-sidebar__item-info">'
        + '<p class="byob-sidebar__item-title">' + escHTML(bi.product.title) + '</p>'
        + '<p class="byob-sidebar__item-variant">' + escHTML(unitInfo(bi.variant.title, bi.variant.price)) + '</p>'
        + '<p class="byob-sidebar__item-price">' + priceStr + '</p>'
        + '</div>'
        + '<button class="byob-sidebar__remove" data-action="remove" data-variant-id="' + bi.variant.id + '">&times;</button>'
        + '</div>';
    }

    // Empty slots
    var slotsCount = Math.min(C.slotsVisible || 3, C.maxItems - count);
    var slotsHTML = '';
    for (var s = 0; s < slotsCount; s++) {
      var slotHint = (s === 0 && hint)
        ? '<span class="byob-sidebar__slot-hint">' + hint + '</span>'
        : '';
      slotsHTML += '<div class="byob-sidebar__slot">'
        + '<span class="byob-sidebar__slot-icon">+</span>'
        + '<div class="byob-sidebar__slot-text"><span>Select a Product</span>' + slotHint + '</div>'
        + '</div>';
    }

    // Price display for toggle
    var priceDisp = '';
    if (count > 0) {
      priceDisp = d > 0
        ? '<span class="byob-price--orig">' + fmt(st) + '</span> ' + fmt(dt)
        : fmt(st);
    }

    // Build sidebar HTML
    sidebarEl.innerHTML = ''
      // Header
      + '<div class="byob-sidebar__header">'
      + '<h3 class="byob-sidebar__title">My Bundle</h3>'
      + '<span class="byob-sidebar__count">' + count + ' / ' + C.maxItems + '</span>'
      + '</div>'
      // Progress
      + '<div class="byob-progress">'
      + '<div class="byob-progress__bar">'
      + '<div class="byob-progress__fill" style="width:' + pct + '%"></div>'
      + markers
      + '</div>'
      + '<div class="byob-progress__labels"><span>Unlock Free Shipping</span><span>' + fmt(maxAmt) + '</span></div>'
      + '</div>'
      // Items + Slots
      + '<div class="byob-sidebar__items">' + itemsHTML + slotsHTML + '</div>'
      // Toggle — One-Time order only (no subscription option)
      + '<div class="byob-sidebar__toggle">'
      + '<label class="byob-sidebar__option is-active">'
      + '<span class="byob-radio is-checked"></span>'
      + '<div class="byob-sidebar__option-info"><span class="byob-sidebar__option-name">One-Time order</span><span class="byob-sidebar__option-desc">One-Time order. No commitment.</span></div>'
      + (count > 0 ? '<span class="byob-sidebar__option-price">' + priceDisp + '</span>' : '')
      + '</label>'
      + '</div>'
      // Checkout
      + '<button class="byob-sidebar__checkout" data-action="checkout"' + (count < (('minItems' in C ? C.minItems : 4)) ? ' disabled' : '') + '>'
      + (count < (('minItems' in C ? C.minItems : 4)) ? 'Add ' + ((('minItems' in C ? C.minItems : 4)) - count) + ' more to bundle' : 'Add Bundle To Cart')
      + '</button>';
  }

  /* ═══════════════════════════════════════════
     Add to Cart
     ═══════════════════════════════════════════ */
  function addToCart() {
    if (!bundle.length) return;
    var minItems = ('minItems' in C ? C.minItems : 4);
    if (totalItems() < minItems) {
      alert('Please add at least ' + minItems + ' products to your bundle.');
      return;
    }
    var btn = sidebarEl.querySelector('.byob-sidebar__checkout');
    btn.disabled = true;
    btn.textContent = 'Adding...';

    var items = [];
    for (var i = 0; i < bundle.length; i++) {
      var bi = bundle[i];
      var payload = {
        id: bi.variant.id,
        quantity: bi.qty,
        properties: { _bundle: C.bundleType || 'byob' }
      };
      // One-time order only — no selling plan needed
      items.push(payload);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function (res) {
      if (!res.ok) {
        return res.json().then(function (errBody) {
          var msg = errBody.description || errBody.message || JSON.stringify(errBody);
          throw new Error(msg);
        });
      }
      return res.json();
    })
    .then(function () {
      // Apply discount code if earned
      var d = activeDiscount();
      var discountCode = d >= 10 ? 'BUNDLE10' : (d >= 5 ? 'BUNDLE5' : '');

      var afterDiscount = function () {
        // Tell the theme to reload cart data
        document.dispatchEvent(new CustomEvent('theme:cart:change', {
          detail: { cart: null },
          bubbles: true
        }));
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));

        // Open the cart drawer
        var cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
        if (cartDrawer) {
          cartDrawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
        } else {
          // Fallback: redirect to cart page if no drawer found
          window.location.href = '/cart';
        }

        // Reset bundle state
        bundle = [];
        refresh();
        btn.disabled = false;
        btn.textContent = 'Add Bundle To Cart';
      };

      if (discountCode) {
        // Apply discount code via AJAX, then open drawer
        fetch('/discount/' + discountCode, { method: 'GET', redirect: 'manual' })
          .then(afterDiscount)
          .catch(afterDiscount);
      } else {
        afterDiscount();
      }
    })
    .catch(function (err) {
      console.error('BYOB cart error:', err);
      btn.disabled = false;
      btn.textContent = 'Add Bundle To Cart';
      alert('Error adding bundle to cart:\n\n' + err.message);
    });
  }

  /* ═══════════════════════════════════════════
     Event Delegation
     ═══════════════════════════════════════════ */
  function handleClick(e) {
    var el = e.target.closest('[data-action]');
    if (!el) return;

    var action = el.dataset.action;

    switch (action) {
      case 'tab':
        activeTab = parseInt(el.dataset.tab, 10);
        var tabs = tabsEl.querySelectorAll('.byob-tab');
        for (var i = 0; i < tabs.length; i++) {
          tabs[i].classList.toggle('is-active', i === activeTab);
        }
        renderGrid();
        break;

      case 'scroll-top':
        root.scrollIntoView({ behavior: 'smooth' });
        break;

      case 'add':
        var pid = parseInt(el.dataset.productId, 10);
        var vid = parseInt(el.dataset.variantId, 10);
        var products = C.tabs[activeTab].products;
        var product = null;
        for (var p = 0; p < products.length; p++) {
          if (products[p].id === pid) { product = products[p]; break; }
        }
        if (!product) break;
        var variant = null;
        for (var v = 0; v < product.variants.length; v++) {
          if (product.variants[v].id === vid) { variant = product.variants[v]; break; }
        }
        if (variant) addItem(product, variant);
        break;

      case 'qty-plus':
        adjustQty(parseInt(el.dataset.variantId, 10), 1);
        break;

      case 'qty-minus':
        adjustQty(parseInt(el.dataset.variantId, 10), -1);
        break;

      case 'remove':
        removeItem(parseInt(el.dataset.variantId, 10));
        break;

      case 'order-type':
        // One-time only, no toggle needed
        break;

      case 'checkout':
        addToCart();
        break;
    }
  }

  function handleChange(e) {
    var sel = e.target.closest('.byob-card__select');
    if (!sel) return;
    var pid = parseInt(sel.dataset.productId, 10);
    selVariants[pid] = parseInt(sel.value, 10);
    renderGrid();
  }

  /* ═══════════════════════════════════════════
     Init
     ═══════════════════════════════════════════ */
  function init() {
    root = document.getElementById('byob-bundle');
    if (!root) return;
    tabsEl = root.querySelector('.byob__tabs');
    gridEl = root.querySelector('.byob__products');
    sidebarEl = root.querySelector('.byob__sidebar-inner');

    renderTabs();
    renderGrid();
    renderSidebar();

    root.addEventListener('click', handleClick);
    root.addEventListener('change', handleChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
